export const getSalesChannelIcon = (salesChannel: string) => {
    switch (salesChannel?.toLowerCase()) {
        case "shopify":
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/shopify_w87tn3.svg"
                    alt="shopify"
                    className="w-4 h-4"
                />
            );
        case "amazon":
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/amazon_1_aeftdf.svg"
                    alt="amazon"
                    className="w-4 h-4"
                />
            );
        case "quickbooks":
        case "quickbooks desktop":
            return (
                <img
                    src="https://storage.googleapis.com/heysynth_files/synth_webapp/quickbooksIcon_poqahg.svg"
                    alt="quickbooks"
                    className="w-4 h-4"
                />
            );
        default:
            return <i className="ri-store-2-fill text-y-10 text-base"></i>;
    }
};
